export default __webpack_public_path__ + "static/media/banner_tmg_racing.e5e95bcd.png";